import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import {BrowserRouter} from 'react-router-dom'
import {ConfigProvider} from "antd-mobile";
import enUS from 'antd-mobile/es/locales/en-US'

// import  VConsole from "vconsole";
// const vConsole = new VConsole();
ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter>
        <ConfigProvider locale={enUS}>
            <App/>
        </ConfigProvider>
    </BrowserRouter>
)